import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { getJson } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { NewsCard, useNewsSaved } from "@/components/news/NewsCard";

/** Three most recent published news with a shortcut to /noticias. Renders nothing if there are none. */
export const LatestNews = () => {
  const { t } = useLang();
  const [items, setItems] = useState([]);
  const { saved, toggle } = useNewsSaved();
  useEffect(() => {
    getJson("/news").then((d) => setItems(Array.isArray(d) ? d.slice(0, 3) : []));
  }, []);
  if (!items.length) return null;
  return (
    <section className="mx-auto max-w-[1440px] px-5 py-24 md:px-10" data-testid="home-latest-news">
      <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div>
          <p className="mono text-xs text-[var(--brick-light)]">{t("nav.news")}</p>
          <h2 className="mt-4 font-display text-5xl leading-[0.95] lg:text-7xl">{t("news.l1")} <em>{t("news.l2")}</em></h2>
        </div>
        <Link to="/noticias" className="btn-ghost self-start md:self-auto" data-testid="home-news-all">{t("news.all")} <ArrowUpRight size={16} /></Link>
      </div>
      <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {items.map((n) => <NewsCard key={n.id} n={n} saved={saved.includes(n.id)} onSave={toggle} />)}
      </div>
    </section>
  );
};
